require(`intersection-observer`);
IntersectionObserver.prototype.POLL_INTERVAL = 100;

import YandexMap from "./../components/yandex-map/yandex-map.js";
import {OrganizationCoord} from "./../const.js";

const mapElement = document.querySelector(`.map-element`);
const mapTextWrapperElement = document.querySelector(`.contacts-wrapper`);

const mediaRules = [
  {
    rule: `default`,
    offset: (textWrapper) => {
      return {
        x: textWrapper.clientWidth / 2
      };
    }
  }, {
    rule: `(max-width: 767px)`,
    offset: {}
  }
];

const yandexMapComponent = new YandexMap(mapElement, mapTextWrapperElement, mediaRules);
yandexMapComponent.init(OrganizationCoord);
